var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.07,
    height: 17.144,
    viewBox: "0 0 17.07 17.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M1.138-2.722.419-.281.031,1.038a.75.75,0,0,0,.928.934l1.322-.391L4.722.863A2.74,2.74,0,0,0,5.766.288C5.809.25,5.85.209,5.891.169l9.506-9.5a2,2,0,0,0,.256-2.516,2,2,0,0,0-.256-.312L14.166-13.4a2,2,0,0,0-2.828,0L1.831-3.891a2.771,2.771,0,0,0-.694,1.169ZM2.575-2.3a1.268,1.268,0,0,1,.263-.475c.019-.019.034-.038.053-.056l7.141-7.137,1.938,1.938L4.831-.891A1.263,1.263,0,0,1,4.3-.575l-.731.216-1.713.5.5-1.712L2.575-2.3Z",
    transform: "translate(0.509 14.634)",
    fill: "#228285",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ade0a83727c2beabe5c62dd2c2ffbe5c.svg";
export { ForwardRef as ReactComponent };